import { useTranslation } from '@klv/hooks/useTranslation';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/slideIndicator.module.scss';

import type { ISlideIndicator } from './types';

const SlideIndicator = ({
  className,
  currentSlide,
  indicatorColor,
  setCurrentSlide,
  totalSlides,
  ...props
}: ISlideIndicator) => {
  const { t } = useTranslation();

  return (
  <div className={generateClassName([className, styles.slideIndicator])} {...props}>
    {Array(totalSlides).fill(0).map((slide, index) => {
      const active = currentSlide === index;
      const Element = active ? 'div' : 'button';
      return (
        <Element
          className={generateClassName([styles.indicator, active && styles.active, styles[indicatorColor]])}
          aria-label={(currentSlide === index) ? `${t('atoms_slideIndicator_currentSlide')}` : `${t('atoms_slideIndicator_goToSlide')} ${index + 1}`}
          key={index}
          onClick={() => setCurrentSlide(index)}
        />
      );
    })}
  </div>
  );
};

export default SlideIndicator;
